import { render, staticRenderFns } from "./ModalProofCancelProject.vue?vue&type=template&id=40dc703c&scoped=true"
import script from "./ModalProofCancelProject.vue?vue&type=script&lang=js"
export * from "./ModalProofCancelProject.vue?vue&type=script&lang=js"
import style0 from "./ModalProofCancelProject.vue?vue&type=style&index=0&id=40dc703c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dc703c",
  null
  
)

export default component.exports